export default __webpack_public_path__ + "static/media/psycho_two.96d1c331.png";